import type { ReactNode } from 'react';

import { cx } from '../lib/class-names';

import styles from './Alert.module.css';

export type AlertTone = 'error' | 'success' | 'info' | 'warning';

/**
 * An inline message.
 *
 * Errors use `role="alert"`, which interrupts a screen reader immediately —
 * appropriate when a submission has just failed. Everything else uses
 * `role="status"`, which waits for a pause rather than talking over the user.
 */
export function Alert({
  tone = 'info',
  title,
  children,
}: {
  tone?: AlertTone;
  title?: string;
  children: ReactNode;
}): React.JSX.Element {
  return (
    <div
      className={cx(styles.alert, styles[tone])}
      role={tone === 'error' ? 'alert' : 'status'}
      aria-live={tone === 'error' ? 'assertive' : 'polite'}
    >
      {title !== undefined && <p className={styles.title}>{title}</p>}
      <div className={styles.body}>{children}</div>
    </div>
  );
}
